/** "R$ 1.234,56" from integer cents. */
export function formatBRL(cents: number): string {
  return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

/**
 * Cents from what someone types in a money field: "1.234,56", "1234,5", "1234.56",
 * "R$ 80" — the last "," or "." followed by 1–2 digits is the decimal separator.
 * Null when it isn't a non-negative amount.
 */
export function parseBRL(input: string): number | null {
  const s = input.replace(/[R$\s]/g, "");
  if (!/^\d[\d.,]*$/.test(s)) return null;
  const m = s.match(/^(.*)[.,](\d{1,2})$/);
  const whole = (m ? m[1] : s).replace(/[.,]/g, "");
  const frac = m ? m[2].padEnd(2, "0") : "00";
  if (!/^\d*$/.test(whole)) return null;
  const cents = Number(whole || "0") * 100 + Number(frac);
  return Number.isSafeInteger(cents) ? cents : null;
}

/** "1234,56" — the editable form of an amount. */
export function centsToInput(cents: number): string {
  return (cents / 100).toFixed(2).replace(".", ",");
}
